
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accept-invite/[[...slug]]",
      function () {
        return require("private-next-pages/accept-invite/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accept-invite/[[...slug]]"])
      });
    }
  